import { useCallback } from 'react';
import { DEFAULT_LANGUAGE } from 'project.config';
import useLocale from './useLocale';

type LocalizedString = string | Record<string, string>;

const useLocalizedString = () => {
  const locale = useLocale();

  const formatString = useCallback(
    (children?: LocalizedString) => {
      if (children !== undefined && typeof children !== 'string') {
        return children?.[locale] || children?.[DEFAULT_LANGUAGE];
      }
      return children || '';
    },
    [locale],
  );

  return { formatString };
};

export default useLocalizedString;
